import React from 'react';
import { color } from 'theme';

export const BackwardIcon = ({ fill = color.red }) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ width: '100%', height: '100%' }}
  >
    {/* Circle */}
    <circle cx="12" cy="12" r="10" fill={fill} stroke="#FFF" strokeWidth="2" />
    {/* Arrow pointing left */}
    <path
      d="M 16 12 L 8 12 M 11 9 L 8 12 L 11 15"
      fill="#FFF"
      stroke="#FFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
